<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="col-lg-12 mb-4">
            <div class="box">
                <ValidationObserver  ref="form">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <div class="box-ttl">Faq</div>
                        </div>
                        <div class="form mt-3">
                            <div class="row mb-3">

                                <ValidationProvider
                                    name="Question"
                                    rules="required|min:2"
                                    v-slot="{errors}"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Question</label>
                                        <input type="text" class="form-control" v-model="faq.question">
                                        <FormError :error="errors[0]" name="Question"></FormError>
                                    </div>
                                </ValidationProvider>

                                <ValidationProvider
                                    name="Answer"
                                    rules="required|min:2"
                                    v-slot="{errors}"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Answer</label>
                                        <textarea  class="form-control height-2" v-model="faq.answer"></textarea>
                                        <FormError :error="errors[0]" name="Answer"></FormError>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="btns-wrap">
                                        <a href="/master-admin/settings/faqs" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                        <a  class="btn btn--secondary w-100 w-sm-auto" @click="validate">Save</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </ValidationObserver>
            </div>

        </div>
    </div>
</template>

<script>
import FaqService from "./Services/FaqService";

export default {
    name: 'FaqItem',
    props: {
        item: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            isUpdate: null,
            loading: true,
            faq: {
                question: null,
                answer: null,

            }
        }
    },
    methods: {
        setData(faq) {
            for (const fullKey in this.item) {
                for (const emptyKey in faq) {
                    if (fullKey === emptyKey) {
                        faq[fullKey] = this.item[emptyKey];
                    }
                }
            }
            this.loading = false
        },
        async saveItem() {
            try {
                await FaqService.saveNewItem(this.faq)
                this.$showSuccessMessage('New FAQ was added!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/faqs'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        async updateExistItem() {
            try {
                await FaqService.updateItem(this.item.id, this.faq)
                this.$showSuccessMessage('FAQ was updated!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/faqs'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        validate() {
            (async () => {

                const valid = await this.$refs.form.validate();
                if (!valid) {
                    this.$showErrorMessage('Info is missing')
                    return
                }
                if (this.isUpdate === false) {
                    await this.saveItem()
                } else {
                    await this.updateExistItem()
                }

            })();
        }
    },
    mounted() {

        if (!this.item) {
            this.isUpdate = false;
            this.loading = false;
        } else {
            this.isUpdate = true
            this.setData(this.faq);
        }

    }
}

</script>



<style scoped>

</style>
